import { FC, SVGAttributes } from 'react';

type LoadingSvgProps = SVGAttributes<SVGElement> & {
    focusedPathClassName?: string;
    pathClassName?: string;
};

export const LoadingSvg: FC<LoadingSvgProps> = ({
    fill,
    focusedPathClassName,
    pathClassName,
    ...props
}) => {
    return (
        <svg viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M8 4.66732V3.33398"
                stroke="#E5E5E5"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={pathClassName}
            />
            <path
                d="M8 12.6673V11.334"
                stroke="#E5E5E5"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={pathClassName}
            />
            <path
                d="M4.66732 8L3.33398 8"
                stroke="#E5E5E5"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={pathClassName}
            />
            <path
                d="M12.6673 8L11.334 8"
                stroke="#828282"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={focusedPathClassName}
            />
            <path
                d="M11.3333 11.3333L10 10"
                stroke="#E5E5E5"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={pathClassName}
            />
            <path
                d="M5.99935 5.99935L4.66602 4.66602"
                stroke="#E5E5E5"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={pathClassName}
            />
            <path
                d="M11.3333 4.66602L10 5.99935"
                stroke="#828282"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={focusedPathClassName}
            />
            <path
                d="M5.99935 10L4.66602 11.3333"
                stroke="#E5E5E5"
                strokeWidth="0.9"
                strokeLinecap="round"
                className={pathClassName}
            />
        </svg>
    );
};
